import { useDateTimeFormat } from '~/hooks';

function formatPeriod(clientApproval, formatDate) {
  if (!clientApproval.periodStart && !clientApproval.periodEnd) return 'All Time';
  if (clientApproval.periodStart && !clientApproval.periodEnd) return `Since ${formatDate(clientApproval.periodStart)}`;
  if (!clientApproval.periodStart && clientApproval.periodEnd) return `Until ${formatDate(clientApproval.periodEnd)}`;

  return `${formatDate(clientApproval.periodStart)} - ${formatDate(clientApproval.periodEnd)}`;
}

export default function ClientApprovalDetails({ clientApproval }) {
  const dateTimeFormat = useDateTimeFormat();
  const formatDate = (value) => dateTimeFormat.format(value);

  return [formatDate(clientApproval.date), formatPeriod(clientApproval, formatDate)].filter(Boolean).join(' - ');
}
